const rememberMe = 'remember-me';

class StorageService {
  useLocal = false;

  constructor() {
    const rememberMeSet = localStorage.getItem(rememberMe);
    this.useLocal = rememberMeSet && rememberMeSet === 'true';
  }

  setLocal(shouldUseLocalStorage) {
    this.useLocal = shouldUseLocalStorage;
  }

  setItem(key, value) {
    return (this.useLocal) ? localStorage.setItem(key, value) : sessionStorage.setItem(key, value);
  }

  getItem(key) {
    return (this.useLocal) ? localStorage.getItem(key) : sessionStorage.getItem(key);
  }

  removeItem(key) {
    return (this.useLocal) ? localStorage.removeItem(key) : sessionStorage.removeItem(key);
  }

  clear() {
    return (this.useLocal) ? localStorage.clear() : sessionStorage.clear();
  }
}


export default new StorageService();
